import React, { useEffect, useRef, useState } from 'react'
import { withPage } from '@sms/plasma-ui';
import IFrameComponent from '../../../components/IFramePage/IFrameComponent';

export interface VeroPageProps {
  children?: React.ReactNode;
  relativePath: string;
}

const VeroPage = (props: VeroPageProps) => {
  const { relativePath } = props;

  const envVars: Record<string, unknown> = typeof window === "undefined" ? process.env
    : (window as any).plasma.environment

  return (
    <>
      <div style={{ height: '100%', width: '100%' }}>
        <IFrameComponent key={'iframe-vero'} option={relativePath} elementId='iframe-vero' source={envVars.VERO_IFRAME_URL} needsReload={false}/>
      </div>
    </>
  )
}

export default withPage(VeroPage);
